import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import DialogHeader from "@shared/ui/dialog/DialogHeader";
import { Button, CircularProgress } from "@mui/material";
import { Icon } from "@shared/icons";
import { useTheme } from "@mui/material";


interface DeleteDialogProps {
    open: boolean;
    cancelDelete: () => void;
    confirmDelete: () => void;
    isDeleting?: boolean;
    title?: string;
    description?: string;
}
export const DeleteDialog: React.FC<DeleteDialogProps> = ({
    open: open,
    cancelDelete: cancelDelete,
    confirmDelete: confirmDeletePurchaseOrder,
    isDeleting,
    title,
    description,
}) => {
    const theme = useTheme();

    return (
        <>
            < Dialog
                open={open}
                onClose={cancelDelete}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeader>
                    <Typography variant="h6" component="div">
                        {title || 'Delete item'}
                    </Typography>
                </DialogHeader>
                <DialogContent>
                    <Typography>
                        {description || 'Are you sure you want to delete this item?<br /> This action cannot be undone.'}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2, borderTop: 1, borderColor: theme.palette.divider }}>
                    <Button
                        onClick={cancelDelete}
                        variant="outlined"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={confirmDeletePurchaseOrder}
                        variant="contained"
                        color="error"
                        startIcon={isDeleting ? <CircularProgress color="inherit" size={20} /> : <Icon icon="Trash01" />}
                        disabled={isDeleting}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog >
        </>
    );
};